module.exports = __webpack_public_path__ + "static/media/ic-increase-green.d5b922f4.svg";